
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 6595"}},[_c('g',{attrs:{"data-name":"Group 6594"}},[_c('path',{attrs:{"data-name":"Path 292","d":"M62.72 18.72L45.27 1.25a4.46 4.46 0 00-6.17 0l-5.82 5.82a4.36 4.36 0 000 6.18l17.45 17.48a4.36 4.36 0 006.16 0l5.82-5.83a4.36 4.36 0 00.01-6.18z"}}),_c('path',{attrs:{"data-name":"Path 293","d":"M32.06 16.17a1.44 1.44 0 00-1.78-.17 36.34 36.34 0 01-18.49 5.71 1.46 1.46 0 00-1.4 1L.05 58.91a1.45 1.45 0 001 1.79 1.43 1.43 0 001.44-.39L19.81 42a3 3 0 00.76-2.4 4.36 4.36 0 114.83 3.83 4.18 4.18 0 01-1 0 2.92 2.92 0 00-2.38.75L3.7 61.48a1.45 1.45 0 001 2.52 1.39 1.39 0 00.4-.06l36.19-10.35a1.45 1.45 0 001.05-1.4 36.33 36.33 0 015.71-18.48 1.44 1.44 0 00-.21-1.78z"}})])])])
          )
        }
      }
    